/** Müvekkil TC / Vergi No yardımcıları */

export const KIMLIK_TIPI_OPTIONS = [
    { value: "TC", label: "T.C. Kimlik No (Şahıs)" },
    { value: "VERGI", label: "Vergi No (Tüzel / Şirket)" },
];

export function inferKimlikTipi(no) {
    const d = String(no || "").replace(/\D/g, "");
    if (d.length === 10) return "VERGI";
    if (d.length === 11) return "TC";
    return "TC";
}

export function kimlikNoLabel(tip) {
    return tip === "VERGI" ? "Vergi No" : "T.C. Kimlik No";
}

export function kimlikNoPlaceholder(tip) {
    return tip === "VERGI" ? "10 haneli vergi numarası" : "11 haneli T.C. kimlik no";
}

export function kimlikNoMaxLength(tip) {
    return tip === "VERGI" ? 10 : 11;
}

export function normalizeKimlikNo(raw, tip) {
    const d = String(raw || "").replace(/\D/g, "");
    const max = kimlikNoMaxLength(tip);
    return d.slice(0, max);
}

export function validateMuvekkilKimlik(kimlikTipi, kimlikNo) {
    const tip = kimlikTipi || "TC";
    const val = normalizeKimlikNo(kimlikNo, tip);
    if (!val) {
        return { ok: false, message: `${kimlikNoLabel(tip)} zorunludur.` };
    }
    if (tip === "VERGI") {
        if (!/^\d{10}$/.test(val)) {
            return { ok: false, message: "Vergi numarası 10 haneli olmalıdır." };
        }
    } else if (!/^\d{11}$/.test(val)) {
        return { ok: false, message: "T.C. Kimlik No 11 haneli olmalıdır." };
    }
    return { ok: true, value: val };
}
